import axios from "axios";
// Production: same-origin'den serve → /api yeterli
// Dev: webpack proxy /api → backend'e yönlendirir
const API_BASE = process.env.REACT_APP_API_BASE ?? "/api";
const api = axios.create({
    baseURL: API_BASE,
    timeout: 15000,
    headers: { "Content-Type": "application/json" },
});
// Request interceptor — token ekle
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});
// Response interceptor — 401'de logout
api.interceptors.response.use((res) => res, (err) => {
    if (err?.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        if (window.location.pathname !== "/login") {
            window.location.href = "/login";
        }
    }
    return Promise.reject(err);
});
export default api;
